
import Swal from 'sweetalert2';
import Rails from '@rails/ujs';

window.Swal = Swal;

// Behavior after clicking the confirm button
const confirmed = (element, result) => {
    if (result.isConfirmed) {  // Changed from result.value to result.isConfirmed
        if (element.getAttribute('data-remote') !== null) {
            let reloadAfterSuccess = element.getAttribute('data-reload') !== null;

            $.ajax({
                method: element.getAttribute('data-method') || 'GET',
                url: element.getAttribute('href')
            });
        } else {
            element.removeAttribute('data-confirm-swal');
            element.click();
        }
    }
};

// Display the confirmation dialog
const showConfirmationDialog = (element) => {
  const message = element.getAttribute('data-confirm-swal');
  const text = element.getAttribute('data-text');

  // HTML elementinin lang attribute'unu al
  const langAttr = document.documentElement.lang || 'en';
  const lang = langAttr.startsWith('tr') ? 'tr' : 'en';

  const translations = {
    en: {
      title: "Are you sure?",
      confirmButton: "Ok",
      cancelButton: "Cancel"
    },
    tr: {
      title: "Emin misiniz?",
      confirmButton: "Tamam",
      cancelButton: "Vazgeç"
    }
  };

  const t = translations[lang];

  Swal.fire({
    title: message || t.title,
    text: text || '',
    icon: 'warning',
    showCancelButton: true,
    cancelButtonText: t.cancelButton,
    confirmButtonText: t.confirmButton,
  }).then(result => confirmed(element, result));
};

  

const allowAction = (element) => {
    if (element.getAttribute('data-confirm-swal') === null) {
        return true;
    }

    showConfirmationDialog(element);
    return false;
};

function handleConfirm(e) {
    if (!allowAction(this)) {
        Rails.stopEverything(e);
    }
}

Rails.delegate(document, 'a[data-confirm-swal]', 'click', handleConfirm);
